import React from 'react';
import { AutoGlassRepair } from './pages/AutoGlassRepair/AutoGlassRepair';
import { ResidentialGlass } from './pages/ResidentialGlass/ResidentialGlass';
import { ShowerDoors } from './pages/ShowerDoors/ShowerDoors';
import { CommercialGlass } from './pages/CommercialGlass/CommercialGlass';
import { EmergencyAutoGlass } from './pages/EmergencyAutoGlass/EmergencyAutoGlass';
export function App() {
  // Simple path-based switch — keeps the project dependency-free.
  const path = typeof window !== 'undefined' ? window.location.pathname.toLowerCase() : '';
  if (path.includes('residential')) {
    return <ResidentialGlass data-id="element-0" />;
  }
  if (path.includes('shower')) {
    return <ShowerDoors data-id="element-1" />;
  }
  if (path.includes('commercial')) {
    return <CommercialGlass data-id="element-2" />;
  }
  if (path.includes('emergency') || path.includes('urgent')) {
    return <EmergencyAutoGlass data-id="element-3" />;
  }
  return <AutoGlassRepair data-id="element-4" />;
}